import { ElementType, ElementTypes, NecessaryFunctionInfo } from "@types";
import { dataKeyToOutputTransformer } from "./answer-item-element/output-transformers";
import { dataKeyToOnUpload } from "./parsed-file-upload-element/on-upload";

export const elementsWithNecessaryFunctions: Partial<
  Record<ElementType, NecessaryFunctionInfo>
> = {
  [ElementTypes.parsedFileUploadElement]: {
    functionName: "onUpload",
    dataKeyToFunctionMap: dataKeyToOnUpload,
  },
  [ElementTypes.answerItemsElement]: {
    functionName: "outputTransformer",
    dataKeyToFunctionMap: dataKeyToOutputTransformer,
  },
};
